import { render, staticRenderFns } from "./ProuductPage.vue?vue&type=template&id=1cf62367&scoped=true"
import script from "./ProuductPage.vue?vue&type=script&lang=js"
export * from "./ProuductPage.vue?vue&type=script&lang=js"
import style0 from "./ProuductPage.vue?vue&type=style&index=0&id=1cf62367&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf62367",
  null
  
)

export default component.exports